// Immutable Firestore organization IDs. Keep organization customizations keyed
// to membership, never to a mutable name or email domain.
export const BEDROCK_ORG_ID = "org_afd41c6f350a";
export const APPTRONIK_ORG_ID = "org_apptronik";

export function isBedrockOrgMember(orgId?: string | null): boolean {
  return orgId?.trim() === BEDROCK_ORG_ID;
}

export const ZENDAR_ORG_ID = "org_2287c9c64e60";

export function isApptronikOrgMember(orgId?: string | null): boolean {
  return orgId?.trim() === APPTRONIK_ORG_ID;
}

export function isZendarOrgMember(orgId?: string | null): boolean {
  return orgId?.trim() === ZENDAR_ORG_ID;
}

// Orgs piloting dataset creation: every member reaches the real Dataset Studio
// page and can build datasets from folders and batches they already have
// access to, without being an admin. The same capability the per-UID
// MARKETPLACE_DATASET_CREATOR_UIDS list grants. Mirrored server-side in
// backend/app/utils/constants.py (MARKETPLACE_DATASET_CREATOR_ORG_IDS) — both
// sides must list an org for it to be fully enabled.
const DATASET_CREATOR_ORG_IDS = new Set<string>([ZENDAR_ORG_ID]);

export function isDatasetCreatorOrgMember(orgId?: string | null): boolean {
  return DATASET_CREATOR_ORG_IDS.has(orgId?.trim() ?? "");
}
